import "core-js/modules/es6.object.define-property";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled, { css } from 'styled-components';
var dropdownCSS = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    appearance: none;\n    background-color: ", ";\n    border: none;\n    margin-bottom: 0;\n    padding: ", ";\n    ", ";\n    ", ";\n    min-width: ", ";\n    cursor: ", ";\n\n    &:focus {\n        ", ";\n    }\n"], ["\n    appearance: none;\n    background-color: ", ";\n    border: none;\n    margin-bottom: 0;\n    padding: ", ";\n    ", ";\n    ", ";\n    min-width: ", ";\n    cursor: ", ";\n\n    &:focus {\n        ", ";\n    }\n"])), function (props) {
  return props.hasCustomHandle ? 'transparent' : props.theme.colors.light;
}, function (props) {
  return props.openOnHover ? props.theme.units.getValues([0, 0.5]) : 0;
}, function (props) {
  return props.fluidWidth ? 'width: 100%' : '';
}, function (props) {
  if (props.disabled) {
    return props.theme.components.input.disabledStyle;
  }

  return !props.hasCustomHandle && props.theme.components.input.inputStyle;
}, function (props) {
  return props.minWidth && props.theme.units.getValue(props.minWidth);
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return !props.hasCustomHandle && props.theme.components.input.focusedStyle;
});
export var DropdownHandle = styled.button.attrs({
  type: 'button'
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), dropdownCSS);
DropdownHandle.displayName = 'DropdownHandle';
export var DropdownHandleDiv = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), dropdownCSS);
DropdownHandleDiv.displayName = 'DropdownHandle';
var templateObject_1, templateObject_2, templateObject_3;